import React from 'react';
import { Form, Row, Col, Card } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
const AffiliatedCompanyForm = _ref => {
  let {
    handleChange,
    affiliatedCompany,
    handleSubmit,
    closeForm
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('affiliated_company_name')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    value: affiliatedCompany.name,
    name: "name",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('affiliated_company_tax_number')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    value: affiliatedCompany.tax_number,
    name: "tax_number",
    onChange: handleChange,
    size: "md",
    type: "text"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('applied_for_research_allowance')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: "applied_for_research_allowance",
    onChange: handleChange,
    size: "md",
    value: affiliatedCompany.applied_for_research_allowance
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }, t('not_specified')), /*#__PURE__*/React.createElement("option", {
    value: "yes"
  }, t('yes')), /*#__PURE__*/React.createElement("option", {
    value: "no"
  }, t('no'))))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('maximum_eligible_assessment_basis')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Form.Control, {
    value: affiliatedCompany.maximum_eligible_assessment_basis,
    name: "maximum_eligible_assessment_basis",
    onChange: handleChange,
    size: "md",
    type: "number"
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('date_of_the_decision')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'date_of_the_decision'
      }
    }),
    selected: affiliatedCompany.date_of_the_decision
  }))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    md: 3
  }, t('date_of_application')), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(DatePicker, {
    onChange: date => handleChange({
      target: {
        value: date,
        name: 'date_of_application'
      }
    }),
    selected: affiliatedCompany.date_of_application
  }))))), /*#__PURE__*/React.createElement(Card.Footer, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => handleSubmit(),
    icon: "save",
    iconPosition: 'left',
    variant: "primary"
  }, t('save')), /*#__PURE__*/React.createElement(Button, {
    className: "ms-2",
    onClick: () => closeForm(),
    variant: "light"
  }, t('close form')))));
};
export default AffiliatedCompanyForm;